import dayjs from 'dayjs';
import {} from 'rrule';
import i18next from 'i18next';
import { ScheduleAvailabilityTypes } from '@frontend/api-schedule-availability';
import { convertScheduleHoursObjectToRRuleObject } from '../../rrule-helper';

const RRULE_DAY_MAP = {
  SU: dayjs().set('d', 0).format('ddd'),
  MO: dayjs().set('d', 1).format('ddd'),
  TU: dayjs().set('d', 2).format('ddd'),
  WE: dayjs().set('d', 3).format('ddd'),
  TH: dayjs().set('d', 4).format('ddd'),
  FR: dayjs().set('d', 5).format('ddd'),
  SA: dayjs().set('d', 6).format('ddd'),
};

/**
 * Converts the BYDAY part of an RRULE string to a human-readable text representation.
 *
 * @param rruleString - The RRULE string containing a BYDAY component (e.g., "FREQ=WEEKLY;BYDAY=MO,WE,FR").
 * @returns A comma-separated string of day names mapped from the RRULE_DAY_MAP, or an empty string if BYDAY is not present.
 */
function rruleByDayToText(rruleString: string) {
  const match = rruleString.match(/BYDAY=([^;\n]+)/);
  if (!match) return '';

  const days = match[1].split(',');
  return days.map((day) => RRULE_DAY_MAP[day as keyof typeof RRULE_DAY_MAP] || day).join(', ');
}

export const getProviderWorkingHoursText = (
  providerWorkingHours: ScheduleAvailabilityTypes.ScheduleAvailabilityByDayOfWeek
): string => {
  const { workingHours } = convertScheduleHoursObjectToRRuleObject(providerWorkingHours);

  if (!workingHours?.length) return '';

  if (workingHours.length === 1) {
    const { rrule } = workingHours[0] || {};
    if (!rrule) return '';

    const daysText = rruleByDayToText(rrule);
    const { startTime, endTime } = (Object.values(providerWorkingHours)[0] || [])[0] || {};
    if (!startTime || !endTime) return '';

    const startTimeText = dayjs(startTime, 'HH:mm').format('h:mm A');
    const endTimeText = dayjs(endTime, 'HH:mm').format('h:mm A');

    return `${daysText} ${startTimeText} - ${endTimeText}`;
  }

  const days = Object.values(providerWorkingHours).length;

  return i18next.t('{{days}} Days', { days, ns: 'schedule' });
};
